import { Box as MuiBox, CircularProgress, styled } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <Box data-testid="loading-spinner">
      <CircularProgress size="5rem" />
    </Box>
  );
};

export default LoadingSpinner;

const Box = styled(MuiBox)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
